import { useEffect, useState } from "react"
import { LineChart } from "@mui/x-charts/LineChart"
import { Autocomplete, TextField, Button } from "@mui/material"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import LoadingComponent from "../../../components/loadingComponent"
import { MultiSelect } from "react-multi-select-component"

import months from "../assets/months"
import years from "../assets/years"
import BuscarIcon from "../../../assets/iconos/Buscar.ico"

// Paleta de colores para las series (ajusta o extiende según necesites)
const COLOR_PALETTE = ["#1976d2", "#dc004e", "#ff9800", "#4caf50", "#9c27b0", "#00acc1"]

export default function BasicLine({ lineData }) {
  // Añadir color a cada serie
  const seriesWithColor = lineData.map((serie, idx) => ({
    ...serie,
    color: serie.color || COLOR_PALETTE[idx % COLOR_PALETTE.length],
  }))

  return (
    <div>
      {/* Leyenda personalizada arriba del gráfico */}
      {seriesWithColor.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            flexWrap: "wrap",
            margin: "20px 0",
          }}
        >
          {seriesWithColor.map((serie) => (
            <div
              key={serie.loccodigo}
              style={{
                display: "flex",
                alignItems: "center",
                maxWidth: 150,
                textAlign: "center",
              }}
            >
              <span
                style={{
                  width: 12,
                  height: 12,
                  backgroundColor: serie.color,
                  display: "inline-block",
                  marginRight: 6,
                  borderRadius: 2,
                }}
              />
              <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{serie.label}</span>
            </div>
          ))}
        </div>
      )}

      <div style={{ display: "flex", justifyContent: "center", marginTop: 0 }}>
        {seriesWithColor.length === 0 ? (
          "No existen datos"
        ) : (
          <LineChart
            width={800}
            height={400}
            series={seriesWithColor}
            xAxis={[
              {
                scaleType: "pointer",
                data: Array.from({ length: 31 }, (_, i) => i + 1),
                label: "Precio de ventas VS días",
                min: 0,
                max: 31,
              },
            ]}
            // Ocultar leyenda nativa de MUI X‑Charts (versión 6.x)
            slotProps={{
              legend: {
                hidden: true,
              },
            }}
            margin={{ top: 20, right: 20, bottom: 40, left: 40 }}
          />
        )}
      </div>
    </div>
  )
}
